import { createFileRoute } from '@tanstack/react-router';

import { ErrorPage } from '@/components/errors';

export const Route = createFileRoute('/error/503')({
  component: ServiceUnavailableError,
});

function ServiceUnavailableError() {
  return <ErrorPage status={503} />;
}
